"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./src/components");
const large_text_1 = require("./src/utils/large-text");
const theme_1 = require("./src/utils/theme");
const WINDOWS_FONT_FAMILY = "'Alan Sans', 'Pretendard', sans-serif";
document.addEventListener('DOMContentLoaded', initializePage);
function initializePage() {
    (0, theme_1.applyTheme)();
    (0, large_text_1.applyLargeText)();
    applyWindowsFont();
    updateDocumentTitle();
}
function applyWindowsFont() {
    if (!/Windows/i.test(navigator.userAgent))
        return;
    document.documentElement.style.setProperty('--font-family', WINDOWS_FONT_FAMILY);
}
function updateDocumentTitle() {
    const path = window.location.pathname.substring(1);
    document.title = `이경수 ${path}`;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDRCQUF5QjtBQUV6Qix1REFBdUQ7QUFDdkQsNkNBQThDO0FBRTlDLE1BQU0sbUJBQW1CLEdBQUcsdUNBQXVDLENBQUE7QUFFbkUsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGtCQUFrQixFQUFFLGNBQWMsQ0FBQyxDQUFBO0FBRTdELFNBQVMsY0FBYztJQUNyQixJQUFBLGtCQUFVLEdBQUUsQ0FBQTtJQUNaLElBQUEsMkJBQWMsR0FBRSxDQUFBO0lBQ2hCLGdCQUFnQixFQUFFLENBQUE7SUFDbEIsbUJBQW1CLEVBQUUsQ0FBQTtBQUN2QixDQUFDO0FBRUQsU0FBUyxnQkFBZ0I7SUFDdkIsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFNBQVMsQ0FBQztRQUFFLE9BQU07SUFFakQsUUFBUSxDQUFDLGVBQWUsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLGVBQWUsRUFBRSxtQkFBbUIsQ0FBQyxDQUFBO0FBQ2xGLENBQUM7QUFFRCxTQUFTLG1CQUFtQjtJQUMxQixNQUFNLElBQUksR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFDbEQsUUFBUSxDQUFDLEtBQUssR0FBRyxPQUFPLElBQUksRUFBRSxDQUFBO0FBQ2hDLENBQUMifQ==